<template>
    <div id="zoom-marker-holder">
      <img class="zoom-marker-img" id="zoom-marker-img-view" alt="zoom-marker-img" name="zoom-marker-img" draggable="false"/>
    </div>
</template>

<script>
    

    export default {
        props: [
            'markerData'
        ],
        data() {
            return {
              addedMarkers: []
            }
        },
        methods: {
          
        },
        computed: {

        },
        mounted () {
          if(this.markerData.position_x !== null && this.markerData.position_y !== null) {
            this.addedMarkers.push(
              {
                src: '/img/issue-marker.svg',
                x: this.markerData.position_x,
                y: this.markerData.position_y,
                draggable: false,
                size: 45,
                hint: {value: this.markerData.marker_number, style:{color:"#ffffff"}}
              }
            );
          }

          var self = this;

          $('#zoom-marker-img-view').zoomMarker({
              src: self.markerData.img_src,
              rate: 0.2,
              width: $('#zoom-marker-holder').width(),
              max: 3000,
              markers: self.addedMarkers,
              move_limit: false
          });
        }
    }
</script>